import React, { useCallback, useContext, useMemo } from 'react';
import * as PropTypes from 'prop-types';

import Checkbox from 'ati-ui-react/components/Checkbox';
import withCarTypes from 'ati-ui-react/HOC/withCarTypes';

import { LocaleContext } from 'contexts';
import styles from './styles.modules.scss';

const stubCarTypes = [
    'тентованный',
    'все закр.+изотерм',
    'все открытые',
    'реф.+изотерм',
    'рефрижератор',
];

const CarTypesOptionsSelector = ({options, selectedValues, onChange}) => {
    const locale = useContext(LocaleContext);
    const getCutLoadingTypes = useCallback((values, stub) => {
        const loadTypesCut = [];
        values.forEach((type) => {
            if (stub.includes(type.name)) {
                loadTypesCut.push(type);
            }
        });
        return loadTypesCut;
    }, []);

    const cutLoadingTypes = useMemo(() => getCutLoadingTypes(options || [], stubCarTypes), [options, getCutLoadingTypes]);

    const handleChange = useCallback((event) => {
        const { value } = event.target;
        if (onChange) {
            setTimeout(() => onChange(value), 0);
        }
    }, [onChange]);

    return (
        <ul className={styles['options']}>
            {cutLoadingTypes.map((item) => (
                <li
                    key={item.id}
                >
                    <Checkbox
                        checked={selectedValues.length && item.id && selectedValues.includes(item.id)}
                        id={`checkbox-${item.nameEng}`}
                        label={locale === 'en' ? item.nameEng : item.name}
                        size="small"
                        value={item.id}
                        onChange={handleChange}
                    />
                </li>
            ))}
        </ul>
    );
};

export default withCarTypes(CarTypesOptionsSelector);

CarTypesOptionsSelector.propTypes = {
    options: PropTypes.array,
    selectedValues: PropTypes.array,
    onChange: PropTypes.func,
};
